import { useTranslation } from "react-i18next";

const useMenuItems = () => {
  const { t } = useTranslation(); // Initialize translation hook

  return [
    {
      label: t("menu.main"),
      type: "HEADER",
    },
    {
      type: "HASHMENU",
      id: 1,
      label: t("menu.dashboard"),
      icon: "ph-duotone ph-chart-pie",
      link: "/dashboard",
    },
    {
      type: "HASHMENU",
      id: 8,
      label: t("menu.statistics"),
      icon: "ph-duotone ph-chart-pie-slice",
      link: "/statistics",
    },
    {
      type: "HASHMENU",
      id: 2,
      label: t("menu.company"),
      icon: "ph-duotone ph-buildings",
      link: "/company",
      submenu: [
        { id: 201, label: t("menu.companyAll"), link: "/company?tab=all" },
        {
          id: 202,
          label: t("menu.companyFeatured"),
          link: "/company?tab=featured",
        },
        // { id: 203, label: t("menu.companyNotFeatured"), link: "/company?tab=notFeatured" },
      ],
    },
    {
      type: "HASHMENU",
      id: 3,
      label: t("menu.users"),
      icon: "ph-duotone ph-users",
      link: "/users",
    },
    {
      label: t("menu.jobs"),
      type: "HEADER",
    },
    {
      type: "HASHMENU",
      id: 14,
      label: t("menu.job"),
      icon: "ph-duotone ph-briefcase",
      link: "/jobs",
      submenu: [
        { id: 15, label: t("menu.jobAll"), link: "/jobs?tab=all" },
        { id: 204, label: t("menu.jobFeatured"), link: "/jobs?tab=featured" },
        // { id: 205, label: t("menu.jobNotFeatured"), link: "/jobs?tab=notFeatured" },
        // { id: 4, label: t("menu.types"), link: "/job-types" },
        { id: 5, label: t("menu.categories"), link: "/job-categories" },
        {
          id: 34,
          label: t("menu.recommendedCategories"),
          link: "/recommended-categories",
        },
        { id: 6, label: t("menu.targetGroups"), link: "/job-target-groups" },
        { id: 17, label: t("menu.qualifications"), link: "/qualifications" },
        {
          id: 433,
          label: t("menu.freeQualifications"),
          link: "/free-qualifications",
        },
        { id: 18, label: t("menu.jobFormats"), link: "/job-formats" },
      ],
    },
    {
      label: t("menu.offers"),
      type: "HEADER",
    },
    {
      type: "HASHMENU",
      id: 322,
      label: t("menu.offer"),
      icon: "ph-duotone ph-briefcase",
      link: "/offers",
      submenu: [
        { id: 323, label: t("menu.list"), link: "/offers" },
        { id: 324, label: t("menu.declineReason"), link: "/decline-reasons" }, // Decline Reason as a sub-child
        {
          id: 325,
          label: t("menu.offerCoachDocuments"),
          link: "/offer-coach-documents",
        },
      ],
    },

    {
      label: t("menu.blog"),
      type: "HEADER",
    },
    {
      type: "HASHMENU",
      id: 8,
      label: t("menu.blogs"),
      icon: "ph-duotone ph-article",
      link: "/blogs",
    },
    {
      label: t("menu.locations"),
      type: "HEADER",
    },
    {
      type: "HASHMENU",
      id: 9,
      label: t("menu.locations"),
      icon: "ph-duotone ph-map-pin",
      link: "/locations",
    },
    {
      label: t("menu.pages"),
      type: "HEADER",
    },
    {
      type: "HASHMENU",
      id: 10,
      label: t("menu.pages"),
      icon: "ph-duotone ph-file-text",
      link: "/pages",
    },
    {
      label: t("menu.qa"),
      type: "HEADER",
    },
    {
      type: "HASHMENU",
      id: 12,
      label: t("menu.qas"),
      icon: "ph-duotone ph-question",
      link: "/qas",
      submenu: [
        { id: 16, label: t("menu.list"), link: "/qas" },
        { id: 11, label: t("menu.qaCategories"), link: "/qa-categories" },
      ],
    },
    {
      label: t("menu.sections"),
      type: "HEADER",
    },
    {
      type: "HASHMENU",
      id: 13,
      label: t("menu.section"),
      icon: "ph-duotone ph-grid-four",
      link: "/sections",
    },
    {
      type: "HASHMENU",
      id: 7,
      label: t("menu.packages"),
      icon: "ph-duotone ph-bell",
      link: "/packages",
    },
    {
      label: t("menu.partners"),
      type: "HEADER",
    },
    {
      type: "HASHMENU",
      id: 35,
      label: t("menu.partners"),
      icon: "ph-duotone ph-handshake",
      link: "/partners",
    },
    {
      type: "HASHMENU",
      id: 36,
      label: t("menu.partnerPageSettings"),
      icon: "ph-duotone ph-gear",
      link: "/partner-page-settings",
    },
    {
      label: t("menu.emails"),
      type: "HEADER",
    },
    {
      type: "HASHMENU",
      id: 37,
      label: t("menu.emails"),
      icon: "ph-duotone ph-envelope",
      link: "/emails",
    },
    {
      label: t("menu.feedback", "Feedback"),
      type: "HEADER",
    },
    {
      type: "HASHMENU",
      id: 38,
      label: t("menu.feedbacks", "Feedback"),
      icon: "ph-duotone ph-chat-dots",
      link: "/feedbacks",
    },
    {
      label: t("menu.auditLogs"),
      type: "HEADER",
    },
    {
      type: "HASHMENU",
      id: 39,
      label: t("menu.auditLogs"),
      icon: "ph-duotone ph-clock-counter-clockwise",
      link: "/audit-logs",
    },
  ];
};

export { useMenuItems };
